






















import { PagePathToSubscribePaidMembership } from '@/models/paid-membership/subscribe/page-path'
import { URL } from '@/util/url'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component
export default class NotFoundPlanSubscribableNewly extends Vue {
  redirect() {
    const nextPath = PagePathToSubscribePaidMembership.parseStringified(location.href).pathAfterApply

    /**
     * MPAとSPA両方のパスを扱うため、vue-routerは使えない
     * 外部サイトへのリダイレクトを防ぐため、リダイレクトURLを現在のドメイン内に限定する
     */
    location.href = URL.createUrlForCurrentOrigin(nextPath)
  }
}
